export default {
  production: {
    apiRoot: "https://api.pia-msgwall.jp"
  },
  staging: {
    apiRoot: "https://stg-api.pia-msgwall.jp"
  },
  development: {
    apiRoot: "https://dev-api.pia-arena.bascule.co.jp"
  },
  local: {
    apiRoot: "https://dev-api.pia-arena.bascule.co.jp"
  }
};
